import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.mobile-numbers.add', {
        url: '/add',
        onEnter,
    });
}

/** @ngInject */
function onEnter($state, $uibModal) {
    $uibModal
        .open({component: 'addPhoneNumber'}).result
        .then(() => $state.go('^.list', {}, {reload: '^'}))
        .catch(() => $state.go('^.list'));
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/add/add-phone-number.state.js